type BrandSpinnerProps = {
  size?: number;
  strokeWidth?: number;
  className?: string;
};

export function BrandSpinner({ size = 24, strokeWidth = 2.5, className }: BrandSpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      role="status"
      aria-label="Loading"
      style={{ animation: "vaon-spin 0.9s linear infinite" }}
    >
      <defs>
        <linearGradient id="vaon-spinner-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFA04A" />
          <stop offset="100%" stopColor="#FF4E2E" />
        </linearGradient>
      </defs>
      <circle
        cx="16"
        cy="16"
        r="12"
        stroke="var(--brand-line)"
        strokeWidth={strokeWidth}
        fill="none"
        opacity="0.4"
      />
      <circle
        cx="16"
        cy="16"
        r="12"
        stroke="url(#vaon-spinner-grad)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
        strokeDasharray="18 60"
      />
      <style>{`
        @keyframes vaon-spin {
          from { transform: rotate(0deg); transform-origin: 50% 50%; }
          to   { transform: rotate(360deg); transform-origin: 50% 50%; }
        }
      `}</style>
    </svg>
  );
}
